// Declaration drafting state. Reads matter.workspace.declaration.
// Shows version, word count, sign-off chip, and theme tags.

import type { DeclarationShape } from "../workspace-shapes";

interface Props {
  declaration: DeclarationShape | undefined;
}

export function DeclarationCard({ declaration }: Props) {
  return (
    <div className="cc-card">
      <div className="cc-card-head">
        <div className="cc-card-title">Personal declaration</div>
        <div className="cc-card-sub">· {declaration?.version ?? "no version"}</div>
      </div>
      <div style={{ padding: "14px 18px 16px" }}>
        {!declaration ? (
          <div style={{ fontSize: 12.5, color: "var(--muted)", marginBottom: 12 }}>
            No declaration drafted yet.
          </div>
        ) : (
          <>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 10,
                marginBottom: 12,
              }}
            >
              <div>
                <div
                  style={{
                    fontSize: 9.5,
                    fontWeight: 700,
                    textTransform: "uppercase",
                    letterSpacing: "0.08em",
                    color: "var(--muted)",
                  }}
                >
                  Words
                </div>
                <div
                  style={{
                    fontVariantNumeric: "tabular-nums",
                    fontSize: 16,
                    fontWeight: 700,
                  }}
                >
                  {declaration.words?.toLocaleString() ?? "—"}
                </div>
              </div>
              <div>
                <div
                  style={{
                    fontSize: 9.5,
                    fontWeight: 700,
                    textTransform: "uppercase",
                    letterSpacing: "0.08em",
                    color: "var(--muted)",
                  }}
                >
                  Sign-off
                </div>
                <div>
                  <span
                    style={{
                      display: "inline-block",
                      padding: "2px 8px",
                      borderRadius: 999,
                      fontSize: 11,
                      fontWeight: 600,
                      background: declaration.signedOff ? "var(--ok-50)" : "var(--warn-50)",
                      color: declaration.signedOff ? "var(--ok-600)" : "var(--warn-600)",
                    }}
                  >
                    {declaration.signedOff ? "Signed" : "Pending"}
                  </span>
                </div>
              </div>
            </div>
            {declaration.themes && declaration.themes.length > 0 && (
              <div>
                <div
                  style={{
                    fontSize: 9.5,
                    fontWeight: 700,
                    textTransform: "uppercase",
                    letterSpacing: "0.08em",
                    color: "var(--muted)",
                    marginBottom: 6,
                  }}
                >
                  Themes
                </div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                  {declaration.themes.map((t, i) => (
                    <span
                      key={i}
                      style={{
                        fontSize: 10,
                        padding: "2px 6px",
                        borderRadius: 4,
                        background: "var(--pa-accent-soft, var(--bg))",
                        color: "var(--pa-accent-strong, var(--ink-2))",
                        border: "1px solid var(--line)",
                      }}
                    >
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
